<div
  *ngIf="pricingRule$ | async as pricingRule"
  class="flex items-center justify-end gap-2"
>
  <ng-container *ngrxLet="isVariable$ as isVariable">
    <small class="unit-type">
      @if (isVariable) {
        Variable Pricing:
      } @else {
        Pricing Rule:
        <ng-container *ngIf="pricingRule.unitType; else noUnit"
          >({{ pricingRule.unitType | splitCamel | titlecase }})</ng-container
        >
        <ng-template #noUnit>(Per Unit)</ng-template>
      }
    </small>
    <mat-button-toggle-group
      *ngIf="pricingRule.type | map: shouldShowPricingRules"
      [value]="selectedItemUid$ | async"
      [hideSingleSelectionIndicator]="true"
      (change)="updateSelected(pricingRule, $event.value)"
    >
      @for (
        ruleItem of pricingRule.ruleItems;
        track ruleItem.uid;
        let index = $index
      ) {
        <mat-button-toggle
          class="rule-item"
          tabindex="-1"
          [value]="ruleItem.uid"
          [checked]="ruleItem.selected"
          [disabled]="disabled || (pricingRule.type | map: isAutoSelected)"
        >
          <div
            class="unit-row-label flex items-center gap-2"
            [matTooltip]="ruleItem.price | currency"
          >
            @if (isVariable) {
              {{ ruleItem.label ?? 'Option ' + (index + 1) }}
            } @else {
              {{ ruleItem.startUnit }}
              <ng-container
                *ngIf="
                  ruleItem.endUnit && ruleItem.endUnit !== ruleItem.startUnit
                "
                >to {{ ruleItem.endUnit }}</ng-container
              >
              <ng-container *ngIf="!ruleItem.endUnit"> & above</ng-container>
            }
          </div>
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </ng-container>
</div>
